<template>
  <div class="homeentertainment">
    <div class="comp-title">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Giải trí
        </h1>
      </div>
    </div>
    <div style="clear: both"></div>

    <ul class="nav nav-tabs nav-custom" role="tablist">
      <li class="nav-item">
        <a class="nav-link active text-uppercase color-text" data-toggle="tab" data-target="#news" @click="getNews('TT', 'news')">Tin tức</a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-uppercase color-text" data-toggle="tab" data-target="#story" @click="getNews('CMT', 'story')">Truyện hay hôm nay</a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-uppercase color-text" data-toggle="tab" data-target="#love" @click="getNews('CSTY', 'love')">Cửa sổ tình yêu</a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-uppercase color-text" data-toggle="tab" data-target="#health" @click="getNews('TSSK', 'health')">Sức khỏe giới tính</a>
      </li>
    </ul>

    <!-- Tab panes -->
    <div class="tab-content">
      <div :id="idTab" class="tab-pane active"><br>
        <div class="col-md-4 float-left featured p-0 position-relative" v-for="item in dataList.slice(0,1)">
          <a :href="checkLogin(loginRequest) == true ? prefixUrl + item.id + '/' + item.alias : 'javascript:void(0)'"
             :title="item.title" @click="redirectTo(checkLogin(loginRequest))">
            <img class="thumbnail" :src="item.thumbnail" />
            <div class="caption position-absolute">
              <h4 class="song color-white">{{ item.title }}</h4>
              <p class="singer color-blue text-right">Đọc tiếp <span class="fa fa-angle-double-right"></span></p>
            </div>
          </a>
        </div>
        <div class="col-md-8 float-right entertainment-normal pr-0">
          <div class="row">
            <div class="col-md-6 position-relative mb-3" v-for="item in dataList.slice(1,5)">
              <a :href="checkLogin(loginRequest) == true ? prefixUrl + item.id + '/' + item.alias : 'javascript:void(0)'"
                 :title="item.title" @click="redirectTo(checkLogin(loginRequest))">
                <img :src="item.thumbnail" class="img-w-60 float-left mr-2"/>
                <h4 class="song color-text">{{ subString(item.title, 55) }}</h4>
                <p class="singer color-blue text-right">Đọc tiếp <span class="fa fa-angle-double-right"></span></p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal :modal-title="settings.modalTitle" :modal-message="settings.loginAlert"></modal>
  </div>
</template>

<script>
  export default {
    name: "Entertainment",
    data () {
      return {
        prefixUrl: this.settings.prefixNews,
        currentCategory: "TT",
        idTab: "story",
        dataList: [],
        loginRequest: null
      }
    },
    methods: {
      getNews(categoryCode, idTab){
        this.currentCategory = categoryCode
        this.idTab = idTab
        axios.post(api.news, {categoryCode: this.currentCategory, pageSize: 5, pageIndex: 1})
          .then(response => {
            this.dataList = response.data.result;
          })
          .catch(e => {
            console.log("Entertainment----");
            console.log(e);
          });
      },
      getParamLogin(){
        axios.post(api.paramLogin, {code: "login"})
          .then(response => {
            var res = response.data.result;
            this.loginRequest = res[0].value;
          })
          .catch(e => {

          });
      }
    },
    watch: {
      "currentCategory": {
        handler: "getNews",
        immediate: true
      },
      "$route.path": {
        handler: function (val) {
          this.getParamLogin();
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .homeentertainment{
    text-align: left;
  }
  .nav-custom .nav-item{
    width: calc(100%/4);
  }
  .song{
    padding-top: 0 !important;
  }
  .comp-title{
    margin: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/web/Entertainment.vue